import { formatNumber } from '@angular/common';

export type TNumericFormatPattern = `${number}.${number}-${number}`;
export type TNumericFormatType = 'percent' | 'decimal' | 'money';

export interface INumericFormatOptions {
  preset?: 'percent' | 'decimal' | 'money';
  pattern?: TNumericFormatPattern /* {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits} */;
  locale?: string;
}

const DEFAULT_FORMAT_OPTIONS: INumericFormatOptions = {
  preset: 'decimal',
  pattern: '1.0-0',
  locale: 'he'
};

export function numericFormat(value: number, options: INumericFormatOptions = {}): string {
  options = { ...DEFAULT_FORMAT_OPTIONS, ...options };
  return formatNumber(value, options.locale, options.pattern.toString());
}
